import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableFooter,
} from "@mui/material";
import {
  HoldingsPageShell,
  SortableHeader,
  EmptyTableRow,
  centerBodyCellSx,
  centerHeadCellSx,
  holdingsPaginationSx,
} from "./holdingsTableShared";

interface Bond {
  id: number;
  isin:string;
  quantity:number;
  price:number;
  amount:number;
  settelmentAmount:number;
  settelmentDate:string;
  yeild:number;
}

interface Props {
  data: Bond[];
  totalPages: number; // Total number of users
  pageSize: number; // Current page size
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void; // Page change handler
  onPageSizeChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void; // Page size change handler
  currentPage: number; // Current page number
  fetchData: () => void;
}

const BONDHoldingsTable: React.FC<Props> = ({
  data,
  totalPages,
  pageSize,
  currentPage,
  onPageChange,
  onPageSizeChange,
  fetchData,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState<Bond[]>([]);
  const [sortColumn, setSortColumn] = useState<keyof Bond | null>(null);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  // const location = useLocation();
  // let selectedData = location?.state?.selectedData||{};

  // console.log("this is current page", selectedData);

  console.log("this is current page", data);
  console.log("this is page size", pageSize);

  const isEmptyObject = (obj: object): boolean => {
    return Object.keys(obj).length === 0;
  };

  useEffect(() => {
    // Filter and sort data whenever the data or search term changes
    let updatedData = data;

    // Search functionality
    if (searchTerm) {
      updatedData = updatedData?.filter((row) =>
        Object.values(row).some(
          (value) =>
            value != null &&
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    // Sorting functionality
    if (sortColumn) {
      updatedData = [...updatedData].sort((a, b) => {
        if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
        if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    }

    setFilteredData(updatedData);
  }, [data, searchTerm, sortColumn, sortOrder]);

  const handleSort = (column: keyof Bond) => {
    setSortColumn(column);
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  const pagedData = filteredData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) ?? [];

  const sortHead = (label: string, column: keyof Bond) => (
    <TableCell sx={centerHeadCellSx}>
      <SortableHeader label={label} onSort={() => handleSort(column)} align="center" />
    </TableCell>
  );

  return (
    <HoldingsPageShell
      title="Bonds"
      subtitle="View bond holdings for this investor."
      searchValue={searchTerm}
      onSearchChange={(value) => {
        setSearchTerm(value);
        setPage(0);
      }}
      searchPlaceholder="Search bond holdings..."
    >
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={centerHeadCellSx}>ISIN</TableCell>
              {sortHead("Quantity", "quantity")}
              {sortHead("Price", "price")}
              {sortHead("Amount", "amount")}
              {sortHead("Settlement Amount", "settelmentAmount")}
              {sortHead("Settlement Date", "settelmentDate")}
              {sortHead("Yield(in %)", "yeild")}
            </TableRow>
          </TableHead>

          <TableBody>
            {pagedData.length === 0 ? (
              <TableRow>
                <EmptyTableRow colSpan={7} message="No bond holdings found" />
              </TableRow>
            ) : (
              pagedData.map((row) => (
                <TableRow key={row.id} hover sx={{ "&:hover": { bgcolor: "#FAFAFA" } }}>
                  <TableCell sx={centerBodyCellSx}>{row?.isin}</TableCell>
                  <TableCell sx={centerBodyCellSx}>{row?.quantity}</TableCell>
                  <TableCell sx={centerBodyCellSx}>
                    {"Rs." + Number(row?.price)?.toFixed(2) || "-"}
                  </TableCell>
                  <TableCell sx={centerBodyCellSx}>
                    {row?.amount ? "Rs." + Number(row?.amount).toFixed(2) : "-"}
                  </TableCell>
                  <TableCell sx={centerBodyCellSx}>
                    {"Rs." + Number(row?.settelmentAmount)?.toFixed(2) || "-"}
                  </TableCell>
                  <TableCell sx={centerBodyCellSx}>{row?.settelmentDate || "-"}</TableCell>
                  <TableCell sx={centerBodyCellSx}>
                    {Number(row?.yeild).toFixed(2) || "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>

          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={filteredData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={onPageChange}
                onRowsPerPageChange={onPageSizeChange}
                sx={holdingsPaginationSx}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </HoldingsPageShell>
  );
};

export default BONDHoldingsTable;
